/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungAufgabenResponseDto } from '../../models/lexplus-anforderung-aufgaben-response-dto';

export interface IndividuelleAnforderungDetailControllerGetIndividuelleAnforderungAufgabenV1$Params {
  individuelleAnforderungID: string;
  erledigtLimit?: number;
}

export function individuelleAnforderungDetailControllerGetIndividuelleAnforderungAufgabenV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerGetIndividuelleAnforderungAufgabenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungAufgabenResponseDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerGetIndividuelleAnforderungAufgabenV1.PATH, 'get');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.query('erledigtLimit', params.erledigtLimit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungAufgabenResponseDto>;
    })
  );
}

individuelleAnforderungDetailControllerGetIndividuelleAnforderungAufgabenV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}/aufgaben';
